import {RegistroEntrenador } from '../../system/RegistroEntrenador/RegistroEntrenador';
import CustomForm from '../../lib/FormValidator/Form/CustomForm'
import { RegistroEntrenadorCurso } from '../../system/RegistroEntrenadorCurso/RegistroEntrenadorCurso'
import { RegistroEntrenadorCursoAssertions } from '../../system/RegistroEntrenadorCurso/RegistroEntrenadorCursoAssertions'
class RegistroEntrenadorCursoForm extends CustomForm {
    protected constructor(
    rec_id: string,
    rec_reid: string,
    rec_horas: number | null,
    rec_descripcion: string,
    rec_tipo: string,
    rec_exterior: boolean)
    {const rea = RegistroEntrenadorCursoAssertions.build()
    super("RegistroEntrenadorCurso", rea)
    this.addInputAsserted('rec_id', rec_id)
    this.addInput('rec_reid', rec_reid)
    this.addInput('rec_horas', rec_horas)
    this.addInput('rec_descripcion', rec_descripcion)
    this.addInput('rec_tipo', rec_tipo)
    this.addInput('rec_exterior', rec_exterior)
}

private static build( rec_id: string,
rec_reid: string,
rec_horas: number | null,
rec_descripcion: string,
rec_tipo: string,
rec_exterior: boolean ) {
    return new this( rec_id,
    rec_reid,
    rec_horas,
    rec_descripcion,
    rec_tipo,
    rec_exterior )
}

static initialize() {
    return this.build( 'new',
    '',
    null,
    '',
    'T',
    false )
}

static with(entity: RegistroEntrenadorCurso) {
    return this.build(entity.getId(),
    entity.getReid(),
    entity.getHoras(),
    entity.getDescripcion(),
    entity.getTipo(),
    entity.getExterior())
}

getIdInput() { return this.getInputByName('rec_id') }

getReidInput() { return this.getInputByName('rec_reid') }

getHorasInput() { return this.getInputByName('rec_horas') }

getDescripcionInput() { return this.getInputByName('rec_descripcion') }

getTipoInput() { return this.getInputByName('rec_tipo') }

getExteriorInput() { return this.getInputByName('rec_exterior') }


toRegistroEntrenadorCurso(): RegistroEntrenadorCurso {
    return RegistroEntrenadorCurso.createFrom(
    this.getIdInput().getValue(),
    this.getReidInput().getValue(),
    this.getHorasInput().getValue(),
    this.getDescripcionInput().getValue(),
    this.getTipoInput().getValue(),
    this.getExteriorInput().getValue() )
}

}

export default RegistroEntrenadorCursoForm
